import { Helmet } from 'react-helmet';
import { Divider, Form } from 'antd';
import { useIntl } from 'react-intl';
import { PageProps } from '@/types/PageProps';
import { DefaultRouteTabs } from '@/components/_common';
import ABCAnalysisForm from '@/components/Reports/StockReports/ABCAnalysisForm';
import ButtonsToGenerateReports from '@/components/Reports/ButtonsToGenerateReports';
import { useReportHandlers } from '@/hooks/useReportHandler';
import useFileLoading, { FileType } from '@/hooks/useFileLoading';
import { useStockAbcCurveReport } from '@/core/domain/questReport/Reports/StockAbcCurve/StockAbcCurve.hook';
import { DateTimeFormat } from '@/utils/moment';
import {
  QuestReportStockAbcCurveFormValues,
  QuestReportStockAbcCurveRequest,
} from '@/core/domain/questReport/Reports/StockAbcCurve/StockAbcCurve.types';
import { QuestResponseType } from '@/core/domain/questReport/Reports/Quotation/Quotation.types';
import { ReportCallback } from '@/hooks/useReportGenerate';

export default function ABCAnalysisPage({ route }: PageProps) {
  const [form] = Form.useForm<QuestReportStockAbcCurveFormValues>();

  const { setFileLoading, setFileUnloading, fileLoading } = useFileLoading();

  const generateReport = useStockAbcCurveReport();

  const handleGenerateReport = async (
    format: FileType,
    callback?: ReportCallback,
  ) => {
    setFileLoading(format);

    try {
      const { companiesIds, initialDate, finalDate, groupIds, ...values } =
        await form.validateFields();

      const obj: QuestReportStockAbcCurveRequest = {
        ...values,
        companiesIds: companiesIds?.toString(),
        responseType:
          format === 'CSV' ? QuestResponseType.CSV : QuestResponseType.PDF,
        startDate: initialDate.format(DateTimeFormat),
        endDate: finalDate.format(DateTimeFormat),
        groupIds: groupIds?.toString(),
      };

      const result = await generateReport.mutateAsync(obj);

      if (callback) {
        callback(result);
      }
    } catch {}

    setFileUnloading(format);
  };

  const { handleView, handlePdf, handleCsv } = useReportHandlers(
    'relatorio_curva_ABC',
    handleGenerateReport,
  );
  return (
    <DefaultRouteTabs route={route.parent} permissions={route.permissions}>
      <Helmet title={useIntl().formatMessage({ id: route.name })} />

      <ABCAnalysisForm form={form} />

      <Divider />

      <ButtonsToGenerateReports
        viewReport={handleView}
        generatePdf={handlePdf}
        generateCsv={handleCsv}
        loading={fileLoading}
      />
    </DefaultRouteTabs>
  );
}
